import { createFileRoute } from "@tanstack/react-router";
import { AgentDetail } from "../../features/agents/agent-detail";

export const Route = createFileRoute("/_authed/$org/$project/agents/$name/$tab")({ component: AgentPage });

function AgentPage() {
  const { org, project, name, tab } = Route.useParams();
  return <AgentDetail scope={{ org, project }} name={name} tab={tab} />;
}
